import { css, createGlobalStyle } from 'styled-components'
import { default as RobotoBlack } from './Roboto-Black.ttf'
import { default as RobotoBold } from './Roboto-Bold.ttf'
import { default as RobotoMed } from './Roboto-Medium.ttf'
import { default as RobotoReg } from './Roboto-Regular.ttf'
import { default as RobotoLight } from './Roboto-Light.ttf'
import { default as RobotoThin } from './Roboto-Thin.ttf'

export const fonts = css`
  @font-face {
    font-family: 'Roboto';
    font-weight: 800;
    font-display: swap;
    src: url(${RobotoBlack}) format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-weight: 700;
    font-display: swap;
    src: url(${RobotoBold}) format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-weight: 500;
    font-display: swap;
    src: url(${RobotoMed}) format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-weight: 400;
    font-display: swap;
    src: url(${RobotoReg}) format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-weight: 200;
    font-display: swap;
    src: url(${RobotoLight}) format('opentype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-weight: 100;
    font-display: swap;
    src: url(${RobotoThin}) format('opentype');
    font-display: fallback;
  }
`

export const Fonts = createGlobalStyle`${fonts}`
